import React from 'react';
import ShopBanner from './ShopBanner/ShopBanner';
import ShopDetails from './ShopDetails/ShopDetails';

const Shop = () => {
    return (
        <div>
           <ShopBanner/>
           <ShopDetails/>
        </div>
    );
};

export default Shop;